import BaseComponent from "../../../../../lib/components/BaseComponent";

import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";
import {Box, IconButton, Tab, Tabs, TextField} from "@mui/material";
import {Component} from "react";
import Button from "@mui/material/Button";

class TabBarDynamicAdd1Test extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      tabs: [], value: 0, contents: []
    };
  }

  handleChange = (event, newValue) => {
    this.setState({value: newValue});
  };

  addTab = (tabTitle, tabContent) => {
    this.setState((prevState) => {
      const newTabId = prevState.tabs.length;
      const newTab = {id: newTabId, label: tabTitle};
      const newContent = {id: newTabId, content: tabContent};
      return {
        tabs: [...prevState.tabs, newTab], value: newTabId, contents: [...prevState.contents, newContent]
      };
    });
  };

  onCLick = (event) => {
    this.addTab('First added Tab', <div className="text-white">{<TextField/>}</div>);
  };

  render() {
    return <VerticalLayout className="sandbox-container gap-4">
      <div>
        <Tabs value={this.state.value} onChange={this.handleChange}>
          {this.state.tabs.map((tab) => (<Tab key={tab.id} label={tab.label}/>))}
        </Tabs>
        {this.state.contents.map((content) => (<TabPanel value={this.state.value} index={content.id} key={content.id}>{content.content}</TabPanel>))}
        <Button variant="contained" color="primary" onClick={this.onCLick}>
          Add Tab
        </Button>
      </div>
    </VerticalLayout>;
  }
}

export class TabPanel extends Component {
  render() {
    const {children, value, index} = this.props;
    return (<div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{padding: '16px'}}>
      <Box sx={{maxWidth: {xs: 320, sm: 480}, bgcolor: 'background.paper'}}>{children}</Box>
    </div>);
  }
}

export default TabBarDynamicAdd1Test;
